import angular from 'angular'

let daynamicModel = angular.module('dynamicModel', []).
  directive('dynamicModel', function ($parse, $compile) {
    'ngInject'
    return {
      restrict: 'A',
      terminal: true,
      priority: 100000,
      link: function (scope, elem, attrs, ctrl) {
        let name = $parse(elem.attr('dynamic-model'))(scope)
        elem.removeAttr('dynamic-model')
        elem.attr('ng-model', name)
        $compile(elem)(scope)
      },
    }
  }).name

export default daynamicModel





// WEBPACK FOOTER //
// ./client/app/common/directive/dynamicModel/dynamicModel.js